module.exports = __webpack_public_path__ + "img/k-pink-woman-front.d7b807c1.jpg";